import React, { useEffect, useState } from 'react';
import { Tree, Tooltip, Flex } from 'antd';
import styles from './scene-animations.module.css';

interface AnimationData {
  name: string;
  clip?: any;
}
interface AnimationInfo {
  objectName: string;
  animations: AnimationData[];
}

export default function SceneAnimations({ assets }) {
  const [animationsData, setAnimationsData] = useState<AnimationInfo[]>([]);

  useEffect(() => {
    const animationsInfo: AnimationInfo[] = [];

    assets.forEach((asset) => {
      if (asset?.props?.asset?.ref?.current) {
        const threeObj = asset.props.asset.ref.current;
        const objectName = asset.props.asset.name;

        let animations: AnimationData[] = [];

        if (threeObj.animations && threeObj.animations.length > 0) {
          for (let i = 0; i < threeObj.animations.length; i++) {
            const name = threeObj.animations[i].name;
            animations.push({
              name,
              clip: threeObj.actions[name],
            });
          }
        }

        if (animations.length > 0) {
          animations.push({
            name: 'Stop all animations',
          });

          animationsInfo.push({
            objectName,
            animations: animations.sort(),
          });
        }
      }
    });

    animationsInfo.sort((a, b) => a.objectName.localeCompare(b.objectName));
    setAnimationsData(animationsInfo);
  }, [assets]);

  const stopActions = (actions) => {
    actions.forEach((action) => {
      if (action.clip?.isRunning()) {
        action.clip.reset();
        action.clip.stop();
      }
    });
  };

  const treeData = animationsData.map((item, index) => ({
    title: item.objectName,
    key: `object-${index}`,
    children: item.animations.map((animName, animIndex) => ({
      title: (
        <Tooltip title={animName.name} placement='right'>
          <button
            className={styles.animationButton}
            onClick={() => {
              stopActions(item.animations);
              const action = animName?.clip;
              if (action) {
                action.play();
              }
            }}
          >
            {animName.name}
          </button>
        </Tooltip>
      ),
      key: `object-${index}-anim-${animIndex}`,
      isLeaf: true,
    })),
  }));

  return (
    <div className={styles.root}>
      {treeData.length > 0 ? (
        <Tree
          defaultExpandAll
          showLine={false}
          className={`${styles.tree} scene-animations-tree`}
          treeData={treeData}
        />
      ) : (
        <span>No animations found in scene objects</span>
      )}
    </div>
  );
}
